export var UsageAlertRecipientsEnum;
(function (UsageAlertRecipientsEnum) {
    /** Owners and admins. */
    UsageAlertRecipientsEnum["ADMINS"] = "admins";
    UsageAlertRecipientsEnum["ALL_MEMBERS"] = "all_members";
})(UsageAlertRecipientsEnum || (UsageAlertRecipientsEnum = {}));
//# sourceMappingURL=organization.interface.js.map